import React, { FC } from 'react';

import { mqMin } from '@lucid/theme';

import Tab from './tab';

interface TabOption {
  label: string;
  value?: string;
}

export interface TabsProps {
  className?: string;
  options: TabOption[];
  onChange: (value: string) => void;
  fullWidth?: boolean;
  value: string | number;
}

const Tabs: FC<TabsProps> = ({ className, fullWidth, onChange, options, value }) => {
  return (
    <div
      className={className}
      css={[
        {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          [mqMin.tabletSmall]: {
            justifyContent: 'flex-start'
          }
        },
        fullWidth && {
          width: '100%'
        }
      ]}
    >
      {options.map(({ label, value: labelValue }, index) => (
        <Tab
          key={label}
          label={label}
          onClick={() => onChange(labelValue || label)}
          selected={value === labelValue || value === index}
        />
      ))}
    </div>
  );
};

export default Tabs;
export { Tabs };
